module.exports = __webpack_public_path__ + "static/vf_mpants2_core.cd2967e6.svg";